<div class="container mt-3">
    <!-- Encabezado -->
    <div
        class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
        <h3 class="fw-semibold text-success mb-0 --bs-success">
            <i class="bi bi-box-seam me-2"></i>
            Clasificación masiva comercializadores
        </h3>
        <span class="text-muted small">
            Consulta y asignación de tipos de comercializadores.
        </span>
    </div>

    <!-- Componente de paginación superior -->
    <app-paginacion-superior
        [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas"
        [totalRegistros]="totalRegistros"
        [limite]="limite"
        [opcionesLimite]="opcionesLimite"
        [textoRegistros]="'empresas'"
        [textoMostrar]="'Mostrar'"
        [mostrarEnlaceRelacionar]="false"
        (paginaAnterior)="onPaginaAnterior()"
        (paginaSiguiente)="onPaginaSiguiente()"
        (cambiarLimite)="onCambiarLimite($event)"></app-paginacion-superior>

    <!-- Tabla de empresas -->
    <div class="table-responsive shadow-sm rounded-3 overflow-hidden">
        <table class="table table-hover align-middle mb-0">
            <thead class="table-success">
                <tr>
                    <th>
                        NIT Empresa
                        <app-icono-filtro
                            tipo="input"
                            placeholder="Filtrar por NIT"
                            (filtrar)="
                                onFiltro('nit', $event)
                            "></app-icono-filtro>
                    </th>
                    <th>
                        Razón Social
                        <app-icono-filtro
                            tipo="input"
                            placeholder="Filtrar por Razón Social"
                            (filtrar)="
                                onFiltro('razonSocial', $event)
                            "></app-icono-filtro>
                    </th>
                    <th>
                        Fecha asignación
                        <app-icono-filtro
                            tipo="input"
                            placeholder="Filtrar por Fecha"
                            (filtrar)="
                                onFiltro('fechaAsignacion', $event)
                            "></app-icono-filtro>
                    </th>
                    <th *appPermiso="'clasificacion_comercializadores'">
                        Tipo de comercializador
                        <app-icono-filtro
                            tipo="select"
                            [opciones]="tiposComercializador"
                            placeholder="Filtrar por Tipo"
                            (filtrar)="
                                onFiltro('tipo', $event)
                            "></app-icono-filtro>
                    </th>
                    <th class="text-center" *appPermiso="'ver_caracterizacion'">Detalle</th>
                </tr>
            </thead>
            <tbody *ngIf="empresas.length > 0">
                <tr
                    *ngFor="let empresa of empresas"
                    class="animate__animated animate__fadeIn">
                    <td>
                        <span class="fw-semibold">
                            {{ empresa.agenteVigilado.nit }}
                        </span>
                    </td>
                    <td>{{ empresa.agenteVigilado.razonSocial }}</td>
                    <td>{{ empresa.fechaAsignacion | date: 'dd/MM/yyyy': 'UTC' }}</td>
                    <td *appPermiso="'clasificacion_comercializadores'">
                        <div class="radios-container d-flex flex-wrap gap-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="tipo{{ empresa.agenteVigilado.nit }}"
                                    value="Grande"
                                    id="grande{{ empresa.agenteVigilado.nit }}"
                                    [(ngModel)]="empresa.tamanoComercializador"
                                    (change)="
                                        onTamanoChange(empresa, 'Grande')
                                    " />
                                <label
                                    class="form-check-label"
                                    for="grande{{
                                        empresa.agenteVigilado.nit
                                    }}">
                                    Grande
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="tipo{{ empresa.agenteVigilado.nit }}"
                                    value="Mediano"
                                    id="mediano{{ empresa.agenteVigilado.nit }}"
                                    [(ngModel)]="empresa.tamanoComercializador"
                                    (change)="
                                        onTamanoChange(empresa, 'Mediano')
                                    " />
                                <label
                                    class="form-check-label"
                                    for="mediano{{
                                        empresa.agenteVigilado.nit
                                    }}">
                                    Mediano
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="tipo{{ empresa.agenteVigilado.nit }}"
                                    value="Pequeño"
                                    id="pequeno{{ empresa.agenteVigilado.nit }}"
                                    [(ngModel)]="empresa.tamanoComercializador"
                                    (change)="
                                        onTamanoChange(empresa, 'Pequeño')
                                    " />
                                <label
                                    class="form-check-label"
                                    for="pequeno{{
                                        empresa.agenteVigilado.nit
                                    }}">
                                    Pequeño
                                </label>
                            </div>
                        </div>
                    </td>
                    <td class="text-center" *appPermiso="'ver_caracterizacion'">
                        <button
                            class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                            (click)="verCaracterizacion(empresa)">
                            <i class="bi bi-eye me-1"></i>
                            Ver Caracterización
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Sin resultados -->
    <div
        *ngIf="empresas.length === 0 && !cargando"
        class="text-center py-5 text-muted">
        <i class="bi bi-inbox fs-1 mb-3"></i>
        <p>
            No se encontraron empresas comercializadoras que coincidan con los
            filtros.
        </p>
    </div>

    <!-- Controles inferiores -->
    <div *ngIf="empresas.length > 0" class="d-flex justify-content-center mt-4">
        <div class="d-flex align-items-center gap-3">
            <button
                class="btn btn-outline-success btn-sm"
                (click)="onPaginaAnterior()"
                [disabled]="paginaActual === 1">
                ‹ Anterior
            </button>
            <span class="text-secondary small">
                Página
                <strong>{{ paginaActual }}</strong>
                de
                <strong>{{ totalPaginas }}</strong>
            </span>
            <button
                class="btn btn-outline-success btn-sm"
                (click)="onPaginaSiguiente()"
                [disabled]="paginaActual === totalPaginas">
                Siguiente ›
            </button>
        </div>
    </div>

    <!-- Información de registros -->
    <div *ngIf="empresas.length > 0" class="mt-2 text-muted small text-center">
        Mostrando {{ empresas.length }} de {{ totalRegistros }} empresas
        comercializadoras.
    </div>

    <!-- Botones de acción -->
    <div class="acciones mt-3 d-flex justify-content-end gap-2">
        <button
            class="btn btn-success d-flex align-items-center"
            (click)="guardar()"
            [disabled]="cargando || empresasSeleccionadas.size === 0"
            [title]="
                empresasSeleccionadas.size === 0
                    ? 'Seleccione al menos una empresa'
                    : 'Guardar cambios'
            ">
            <i class="bi bi-check-circle me-1" *ngIf="!cargando"></i>
            <i class="bi bi-hourglass-split me-1" *ngIf="cargando"></i>
            <span *ngIf="!cargando">
                Guardar
                <span
                    class="badge bg-light text-success ms-1"
                    *ngIf="empresasSeleccionadas.size > 0">
                    {{ empresasSeleccionadas.size }}
                </span>
            </span>
            <span *ngIf="cargando">Guardando...</span>
        </button>
        <!--button
            class="btn btn-outline-secondary d-flex align-items-center"
            (click)="generarReporte()">
            <i class="bi bi-file-earmark-text me-1"></i>
            Generar reporte
        </button-->
    </div>
</div>
